import { VALIDATION_TEXTS } from "../constants/texts";
import { PAYMENT_SUBJECT_CONFIG } from "../constants/payment";
import { kopeikiToRubles } from "../shared/PaymentForm/helpers";
import { getLocalCurrencyStr } from "./formatters";

/**
 * @desc: подставляет первые 2 цифры ctn в соответствии с маской и типом оплачиваемой услуги (телефон/интернет)
 * @param ctn
 * @param paymentSubject { string } тип оплачиваемой услуги (телефон/интернет)
 * @param isFixInternetMask { boolean } определяет, нужно ли фиксировать маску для интернета
 * @returns {string}
 */
export var fixMaskMatch = function fixMaskMatch(ctn, paymentSubject, isFixInternetMask) {
  var newVal = ctn;
  var ctnStrLength = ctn.trim().length;
  if (paymentSubject === PAYMENT_SUBJECT_CONFIG.cellphone.id && ctnStrLength > 0) {
    newVal = "+7".concat(newVal.replace(/^\+\d/g, ''));
  }
  if (paymentSubject === PAYMENT_SUBJECT_CONFIG.internet.id && isFixInternetMask) {
    if (ctnStrLength === 1) {
      // eslint-disable-next-line prefer-destructuring
      newVal = '08'[0];
    } else if (ctnStrLength === 2) {
      newVal = '08';
    } else if (ctnStrLength > 2 && ctn.substring(0, 2) !== '08') {
      newVal = "08".concat(newVal.slice(2));
    }
  }
  return newVal;
};

/**
 * @desc: проверяет, корректна ли сумма
 * @param sum
 * @param minSum
 * @param maxSum
 * @returns {string}
 */
export var validateSum = function validateSum(sum, minSum, maxSum) {
  if (typeof sum !== 'number') {
    return VALIDATION_TEXTS.invalidData;
  }
  if (!sum) {
    return VALIDATION_TEXTS.required;
  }
  if (sum < minSum) {
    return "".concat(VALIDATION_TEXTS.lessThanMin, " ").concat(getLocalCurrencyStr(+kopeikiToRubles(minSum)));
  }
  if (sum > maxSum) {
    return "".concat(VALIDATION_TEXTS.moreThanMax, " ").concat(getLocalCurrencyStr(+kopeikiToRubles(maxSum)));
  }
  return '';
};